import { render, staticRenderFns } from "./VatReportRedeemedCards.vue?vue&type=template&id=23766260&"
import script from "./VatReportRedeemedCards.vue?vue&type=script&lang=js&"
export * from "./VatReportRedeemedCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports